exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-49d67a98] .el-upload{width:100%}", ""]);

// exports
